<template>
  <div>
    <b-modal
      hide-footer
      no-close-on-esc
      :title-html="`<div class='d-flex align-items-center'><span class='lock'></span>&nbsp;<span>Authentication Required!</span></div>`"
      :ref="refId"
      :id="refId"
      header-class="managerAuthPop__header_class"
      :modal-class="
        isNovoClient
          ? 'managerAuthPop__modal_class managerAuthPop__modal_class--pin'
          : 'managerAuthPop__modal_class'
      "
      :content-class="isNovoClient ? 'managerAuthPop__content_class--pin' : ''"
      title-class="managerAuthPop__title_class"
      centered
      no-fade
      no-stacking
      no-enforce-focus
      no-close-on-backdrop
      @shown="onModalShown"
      @hidden="onModalHidden"
    >
      <input
        ref="cardScanInput"
        v-model="cardScanData"
        type="text"
        class="manager-auth-hidden-scanner-input"
        autocomplete="off"
        tabindex="-1"
        aria-hidden="true"
        @keyup.enter="authenticateByCard"
        @input="onCardScanInput"
        @blur="onCardScanBlur"
      />
      <div v-if="isNovoClient" class="manager-auth-pin">
        <div class="manager-auth-pin__fields">
          <div class="manager-auth-pin__field">
            <label class="manager-auth-pin__label">User PIN</label>
            <div
              class="manager-auth-pin__box-wrap"
              :class="{ active: selectedType == 'userpin' }"
              @click="focusPinInput('userpin')"
            >
              <input
                @click="onClickInputType('userpin')"
                inputmode="numeric"
                pattern="[0-9]*"
                v-model="userpin"
                type="password"
                ref="userpin"
                class="manager-auth-pin__native-input"
                :disabled="submitted"
                @input="checkLength"
                @keyup.enter="onPinEnter('userpin')"
              />
              <span
                v-for="index in 4"
                :key="'user-pin-box-' + index"
                class="manager-auth-pin__digit-box"
                :class="{
                  filled: getPinDigit(userpin, index - 1),
                  focused: isPinDigitFocused('userpin', index - 1),
                }"
              >
                {{ getPinDigit(userpin, index - 1) ? "•" : "" }}
              </span>
            </div>
          </div>
          <div class="manager-auth-pin__field">
            <label class="manager-auth-pin__label">Password PIN</label>
            <div
              class="manager-auth-pin__box-wrap"
              :class="{ active: selectedType == 'passwordpin' }"
              @click="focusPinInput('passwordpin')"
            >
              <input
                @click="onClickInputType('passwordpin')"
                inputmode="numeric"
                pattern="[0-9]*"
                v-model="passwordpin"
                type="password"
                ref="userpasswordpin"
                class="manager-auth-pin__native-input"
                :disabled="submitted"
                @input="onPasswordPinInput"
                @keyup.enter="onPinEnter('passwordpin')"
              />
              <span
                v-for="index in 4"
                :key="'password-pin-box-' + index"
                class="manager-auth-pin__digit-box"
                :class="{
                  filled: getPinDigit(passwordpin, index - 1),
                  focused: isPinDigitFocused('passwordpin', index - 1),
                }"
              >
                {{ getPinDigit(passwordpin, index - 1) ? "•" : "" }}
              </span>
            </div>
          </div>
        </div>

        <div class="manager-auth-pin__pad">
          <button
            v-for="(value, index) in phone_value"
            :key="'pin-key-' + index"
            type="button"
            class="manager-auth-pin__key"
            :class="{
              'manager-auth-pin__key--muted':
                value.name == '' || index == phone_value.length - 1,
            }"
            :disabled="submitted"
            @click.prevent.stop="
              index == phone_value.length - 1
                ? onSliceNumber()
                : value.name == ''
                ? clearPinInput()
                : onClickNumber(index)
            "
          >
            <span v-if="value.name != ''">{{ value.name }}</span>
            <span v-else>C</span>
          </button>
        </div>

        <div class="manager-auth-pin__actions">
          <button
            @click.prevent.stop="$bvModal.hide(refId)"
            class="btn btn-sm btn-outline-primary"
            style="color: var(--blue)"
            :disabled="submitted"
          >
            Cancel
          </button>
          <button
            @click.prevent.stop="authenticateLogin"
            class="btn btn-sm btn-primary"
            :disabled="submitted"
          >
            <span
              v-if="submitted"
              class="spinner-border spinner-border-sm mr-1"
              role="status"
              aria-hidden="true"
            ></span>
            Authenticate
          </button>
        </div>
        <!-- <div class="text-center mt-2">
          <small
            class="text-muted"
            style="cursor: pointer; font-size: 11px; text-decoration: underline"
            @click="toggleManualScan"
          >
            <i class="fa fa-id-card-o"></i>
            {{
              showManualScan
                ? "Hide manual scan input"
                : "Or swipe card / scan badge (test manually)"
            }}
          </small>
          <div
            v-if="showManualScan"
            class="d-flex align-items-center mt-2 px-2"
            style="max-width: 320px; margin: 0 auto"
          >
            <input
              ref="manualScanInput"
              v-model="cardScanData"
              type="text"
              placeholder="Enter card or badge ID"
              class="form-control form-control-sm mr-2"
              @keyup.enter="authenticateByCard"
            />
            <button
              type="button"
              class="btn btn-sm btn-primary"
              style="white-space: nowrap"
              @click="authenticateByCard"
            >
              Scan
            </button>
          </div>
        </div> -->
      </div>
      <div v-else class="row mx-0">
        <div class="col-12">
          <div class="col-lg-10 mx-auto align-self-center">
            <div class="">
              <div class="input-material">
                <input
                  type="text"
                  v-model="username"
                  v-on:keyup.enter="authenticateLogin"
                  name="username"
                  id="username"
                  required
                  placeholder="username"
                  :disabled="submitted"
                  @click="onClickInputHandler('username')"
                />
                <label>Username</label>
              </div>
              <div v-if="showKeyBoard">
                <VkeyboardFloat
                  :ID="'username'"
                  :onClickFun="
                    () => {
                      showUsernameVKeyboard = !showUsernameVKeyboard;
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'username'"
                  :showOrHide="showUsernameVKeyboard"
                  :initialValue="username"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="authenticateLogin()"
                  @changeKeyboardInput="username = $event"
                  @onClickClose="
                    () => {
                      showUsernameVKeyboard = false;
                    }
                  "
                />
              </div>
              <p class="error_message"></p>
            </div>
            <div class="input-material">
              <input
                type="password"
                v-model="password"
                v-on:keyup.enter="authenticateLogin"
                name="password"
                id="password"
                required
                placeholder="password"
                :disabled="submitted"
                @click="onClickInputHandler('password')"
              />
              <label>Password</label>
            </div>
            <div v-if="showKeyBoard">
              <VkeyboardFloat
                :ID="'password'"
                :onClickFun="
                  () => {
                    showPassVKeyboard = !showPassVKeyboard;
                  }
                "
              />
              <Vkeyboard
                :inputName="'password'"
                :initialValue="password"
                :showOrHide="showPassVKeyboard"
                :hideTypingInput="true"
                @onChangeEvent="() => {}"
                @onKeyEnter="authenticateLogin()"
                @changeKeyboardInput="password = $event"
                @onClickClose="
                  () => {
                    showPassVKeyboard = false;
                  }
                "
              />
            </div>
            <p class="error_message"></p>
            <div class="d-flex mt-1 justify-content-center">
              <button
                @click.prevent.stop="$bvModal.hide(refId)"
                class="btn btn-sm btn-outline-primary mr-5"
                style="color: var(--blue)"
                :disabled="submitted"
              >
                Cancel
              </button>
              <button
                @click.prevent.stop="authenticateLogin"
                class="btn btn-sm btn-primary"
                :disabled="submitted"
              >
                <span
                  v-if="submitted"
                  class="spinner-border spinner-border-sm mr-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Authenticate
              </button>
            </div>
            <div class="text-center mt-2">
              <small
                class="text-muted"
                style="
                  cursor: pointer;
                  font-size: 11px;
                  text-decoration: underline;
                "
                @click="toggleManualScan"
              >
                <i class="fa fa-id-card-o"></i>
                {{
                  showManualScan
                    ? "Hide manual scan input"
                    : "Or swipe card / scan badge (test manually)"
                }}
              </small>
              <div
                v-if="showManualScan"
                class="d-flex align-items-center mt-2 px-2"
                style="max-width: 320px; margin: 0 auto"
              >
                <input
                  ref="manualScanInputStandard"
                  v-model="cardScanData"
                  type="text"
                  placeholder="Enter card or badge ID"
                  class="form-control form-control-sm mr-2"
                  @keyup.enter="authenticateByCard"
                />
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  style="white-space: nowrap"
                  :disabled="submitted"
                  @click="authenticateByCard"
                >
                  Scan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PosService from "@/services/PosService.js";
import { BASEURL } from "@/config/index";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import ElectronAppService from "@/services/ElectronAppService";
import { CLIENT_NAME } from "@/helper/Role";
import { sanitizeCardSwipe, extractCleanCardScan } from "@/helper/collection";

export default {
  props: {
    showKeyBoard: {
      type: Boolean,
      default: true,
    },
    refId: {
      type: String,
      default: "authManagerLoginPopup",
    },
    moduleName: {
      type: String,
      default: "default",
    },
    onCheckAuth: {
      type: Function,
      default: () => console.log("default function"),
    },
  },
  components: {
    Vkeyboard,
    VkeyboardFloat,
  },
  data() {
    return {
      loaderInstance: null,
      username: "",
      password: "",
      userpin: "",
      passwordpin: "",
      cardScanData: "",
      selectedType: "userpin",
      phone_value: [
        { name: "1" },
        { name: "2" },
        { name: "3" },
        { name: "4" },
        { name: "5" },
        { name: "6" },
        { name: "7" },
        { name: "8" },
        { name: "9" },
        { name: "" },
        { name: "0" },
        { name: "<-" },
      ],
      showVKeyboard: false,
      showPassVKeyboard: false,
      showUsernameVKeyboard: false,
      submitted: false,
      showManualScan: false,
      scanTimer: null,
      isModalOpen: false,
      lastScanKeyTime: 0,
    };
  },
  watch: {
    username(newVal) {
      if (newVal && (newVal.startsWith(";") || newVal.startsWith("%"))) {
        this.cardScanData = extractCleanCardScan(newVal) || newVal;
        this.username = "";
        this.authenticateByCard();
      }
    },
    userpin(newVal) {
      const raw = String(newVal || "");
      if (
        raw.startsWith(";") ||
        raw.startsWith("%") ||
        /[a-zA-Z\-_]/.test(raw) ||
        raw.length > 4
      ) {
        this.userpin = "";
        const extracted = extractCleanCardScan(raw);
        if (extracted) {
          this.cardScanData = extracted;
        }
        this.focusScannerInput();
        this.triggerScanDebounce();
      }
    },
    passwordpin(newVal) {
      const raw = String(newVal || "");
      if (
        raw.startsWith(";") ||
        raw.startsWith("%") ||
        /[a-zA-Z\-_]/.test(raw) ||
        raw.length > 4
      ) {
        this.passwordpin = "";
        const extracted = extractCleanCardScan(raw);
        if (extracted) {
          this.cardScanData = extracted;
        }
        this.focusScannerInput();
        this.triggerScanDebounce();
      }
    },
    cardScanData(newVal) {
      const raw = String(newVal || "").trim();
      if (
        raw.startsWith(";") ||
        raw.startsWith("%") ||
        raw.length >= 25 ||
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
          raw
        )
      ) {
        this.triggerScanDebounce();
      }
    },
  },
  computed: {
    isNovoClient() {
      return CLIENT_NAME.NOVO == this.CLIENT_SETUP_NAME;
    },
  },
  mounted() {},
  beforeDestroy() {
    this.isModalOpen = false;
    this.removeGlobalListeners();
    if (this.scanTimer) {
      clearTimeout(this.scanTimer);
      this.scanTimer = null;
    }
  },
  methods: {
    toggleManualScan() {
      this.showManualScan = !this.showManualScan;
      if (this.showManualScan) {
        this.$nextTick(() => {
          if (this.$refs["manualScanInput"]) {
            this.$refs["manualScanInput"].focus();
          } else if (this.$refs["manualScanInputStandard"]) {
            this.$refs["manualScanInputStandard"].focus();
          }
        });
      } else {
        this.$nextTick(() => {
          if (this.isNovoClient) {
            this.focusPinInput("userpin");
          } else if (this.$refs["username"]) {
            this.$refs["username"].focus();
          }
        });
      }
    },
    onModalShown() {
      this.isModalOpen = true;
      this.clearPinInput();
      this.resetAuthFields();
      this.submitted = false;
      this.addGlobalListeners();
      this.focusScannerInput();
    },
    onModalHidden() {
      this.isModalOpen = false;
      this.removeGlobalListeners();
      if (this.scanTimer) {
        clearTimeout(this.scanTimer);
        this.scanTimer = null;
      }
      this.resetAuthFields();
    },
    addGlobalListeners() {
      this.removeGlobalListeners();
      window.addEventListener("click", this.handleGlobalClick, true);
      window.addEventListener("keydown", this.handleGlobalKeyDown, true);
    },
    removeGlobalListeners() {
      window.removeEventListener("click", this.handleGlobalClick, true);
      window.removeEventListener("keydown", this.handleGlobalKeyDown, true);
    },
    focusScannerInput() {
      if (!this.isModalOpen) return;
      if (this.$refs["cardScanInput"]) {
        this.$refs["cardScanInput"].focus();
      }
      this.$nextTick(() => {
        if (!this.isModalOpen) return;
        if (
          this.$refs["cardScanInput"] &&
          document.activeElement !== this.$refs["cardScanInput"]
        ) {
          const active = document.activeElement;
          const isOtherValidInput =
            active &&
            (active === this.$refs["userpin"] ||
              active === this.$refs["userpasswordpin"] ||
              active === this.$refs["manualScanInput"] ||
              active === this.$refs["manualScanInputStandard"] ||
              active === this.$refs["username"] ||
              active === this.$refs["password"]);
          if (!isOtherValidInput) {
            this.$refs["cardScanInput"].focus();
          }
        }
      });
    },
    handleGlobalClick(e) {
      if (!this.isModalOpen) return;
      const target = e && e.target;
      if (
        target &&
        (target.tagName === "INPUT" || target.tagName === "TEXTAREA") &&
        target !== this.$refs["cardScanInput"]
      ) {
        return;
      }
      if (
        target &&
        target.closest &&
        target.closest(".manager-auth-pin__box-wrap")
      ) {
        return;
      }
      this.focusScannerInput();
    },
    onCardScanBlur() {
      if (!this.isModalOpen) return;
      setTimeout(() => {
        if (!this.isModalOpen) return;
        const active = document.activeElement;
        const isOtherValidInput =
          active &&
          (active === this.$refs["userpin"] ||
            active === this.$refs["userpasswordpin"] ||
            active === this.$refs["manualScanInput"] ||
            active === this.$refs["manualScanInputStandard"] ||
            active === this.$refs["username"] ||
            active === this.$refs["password"]);
        if (!isOtherValidInput) {
          this.focusScannerInput();
        }
      }, 30);
    },
    handleGlobalKeyDown(e) {
      if (!this.isModalOpen || !e || !e.key) return;
      if (this.submitted) {
        if (e.key === "Enter") {
          e.preventDefault();
        }
        return;
      }
      if (
        e.key === "Shift" ||
        e.key === "Control" ||
        e.key === "Alt" ||
        e.key === "Meta" ||
        e.key === "CapsLock" ||
        e.key === "Tab" ||
        e.key === "Escape"
      ) {
        return;
      }

      const now = Date.now();
      const timeSinceLastKey = now - (this.lastScanKeyTime || 0);
      this.lastScanKeyTime = now;

      const active = document.activeElement;
      const isScannerFocused = active === this.$refs["cardScanInput"];
      const isPinInput =
        active === this.$refs["userpin"] ||
        active === this.$refs["userpasswordpin"];
      const isOtherInput =
        active &&
        (active === this.$refs["manualScanInput"] ||
          active === this.$refs["manualScanInputStandard"] ||
          active === this.$refs["username"] ||
          active === this.$refs["password"]);

      if (isScannerFocused) {
        if (e.key === "Enter") {
          e.preventDefault();
          this.authenticateByCard();
        }
        return;
      }

      if (isOtherInput) {
        if (e.key === ";" || e.key === "%") {
          e.preventDefault();
          this.cardScanData = e.key;
          this.focusScannerInput();
          this.triggerScanDebounce();
        }
        return;
      }

      if (isPinInput) {
        const isTrackStart = e.key === ";" || e.key === "%";
        const isNonDigit = !/^[0-9]$/.test(e.key);
        const isRapidScan = timeSinceLastKey < 45;

        // If card track start or non-digit (like hex letters a-f in UUID) or rapid scanner keystroke
        if (
          isTrackStart ||
          isNonDigit ||
          (isRapidScan && this.cardScanData.length > 0)
        ) {
          e.preventDefault();
          this.userpin = "";
          this.passwordpin = "";
          this.focusScannerInput();
          if (e.key === "Enter") {
            this.authenticateByCard();
          } else if (e.key.length === 1) {
            this.cardScanData = (this.cardScanData || "") + e.key;
            this.triggerScanDebounce();
          }
          return;
        }

        // Normal single digit typing
        return;
      }

      if (e.key === "Enter") {
        e.preventDefault();
        this.authenticateByCard();
        return;
      }

      if (e.key.length === 1) {
        e.preventDefault();
        this.cardScanData = (this.cardScanData || "") + e.key;
        this.focusScannerInput();
        this.triggerScanDebounce();
      }
    },
    triggerScanDebounce() {
      if (this.submitted) return;
      if (this.scanTimer) clearTimeout(this.scanTimer);
      this.scanTimer = setTimeout(() => {
        if (!this.submitted) {
          this.authenticateByCard();
        }
      }, 200);
    },
    onCardScanInput() {
      if (this.submitted) return;
      const raw = String(this.cardScanData || "").trim();
      if (
        raw.startsWith(";") ||
        raw.startsWith("%") ||
        raw.length >= 25 ||
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
          raw
        )
      ) {
        this.triggerScanDebounce();
      }
    },
    getPinDigit(value, index) {
      return String(value || "").charAt(index);
    },
    isPinDigitFocused(type, index) {
      if (this.selectedType != type) return false;
      const value = type == "userpin" ? this.userpin : this.passwordpin;
      const activeIndex = Math.min(String(value || "").length, 3);
      return index == activeIndex;
    },
    limitPin(type) {
      const pinValue = String(this[type] || "")
        .replace(/\D/g, "")
        .slice(0, 4);
      this[type] = pinValue;
      return pinValue;
    },
    focusPinInput(type) {
      this.onClickInputType(type);
      this.$nextTick(() => {
        const refName = type == "userpin" ? "userpin" : "userpasswordpin";
        if (this.$refs[refName]) {
          this.$refs[refName].focus();
        }
      });
    },
    onClickInputType(type) {
      this.selectedType = type;
    },
    maybeAutoSubmitPinLogin() {
      if (this.submitted) return;
      if (
        String(this.userpin || "").length >= 4 &&
        String(this.passwordpin || "").length >= 4
      ) {
        this.authenticateLogin();
      }
    },
    onPinEnter(type) {
      if (this.submitted) return;
      if (type == "userpin") {
        const raw = String(this.userpin || "");
        if (
          raw.startsWith(";") ||
          raw.startsWith("%") ||
          /[a-zA-Z\-_]/.test(raw) ||
          raw.length > 4
        ) {
          this.userpin = "";
          const extracted = extractCleanCardScan(raw);
          if (extracted) {
            this.cardScanData = extracted;
          }
          this.focusScannerInput();
          this.authenticateByCard();
          return;
        }
        if (
          this.$refs["userpasswordpin"] &&
          (!this.passwordpin || this.passwordpin.length < 4)
        ) {
          this.onClickInputType("passwordpin");
          this.$refs["userpasswordpin"].focus();
          return;
        }
      } else if (type == "passwordpin") {
        const raw = String(this.passwordpin || "");
        if (
          raw.startsWith(";") ||
          raw.startsWith("%") ||
          /[a-zA-Z\-_]/.test(raw) ||
          raw.length > 4
        ) {
          this.passwordpin = "";
          const extracted = extractCleanCardScan(raw);
          if (extracted) {
            this.cardScanData = extracted;
          }
          this.focusScannerInput();
          this.authenticateByCard();
          return;
        }
      }
      this.authenticateLogin();
    },
    onPasswordPinInput() {
      const raw = String(this.passwordpin || "");
      if (
        raw.startsWith(";") ||
        raw.startsWith("%") ||
        /[a-zA-Z\-_]/.test(raw) ||
        raw.length > 4
      ) {
        this.passwordpin = "";
        const extracted = extractCleanCardScan(raw);
        if (extracted) {
          this.cardScanData = extracted;
        }
        this.focusScannerInput();
        this.triggerScanDebounce();
        return;
      }
      this.limitPin("passwordpin");
      this.maybeAutoSubmitPinLogin();
    },
    checkLength() {
      const raw = String(this.userpin || "");
      if (
        raw.startsWith(";") ||
        raw.startsWith("%") ||
        /[a-zA-Z\-_]/.test(raw) ||
        raw.length > 4
      ) {
        this.userpin = "";
        const extracted = extractCleanCardScan(raw);
        if (extracted) {
          this.cardScanData = extracted;
        }
        this.focusScannerInput();
        this.triggerScanDebounce();
        return;
      }
      let stringText = this.limitPin("userpin");
      if (
        stringText &&
        stringText.length > 3 &&
        this.$refs["userpasswordpin"]
      ) {
        this.onClickInputType("passwordpin");
        this.$refs["userpasswordpin"].focus();
      }
      this.maybeAutoSubmitPinLogin();
    },
    onClickNumber(number) {
      if (this.submitted) return;
      const keyValue = this.phone_value[number]
        ? this.phone_value[number].name
        : "";
      if (!keyValue || keyValue == "<-") return;
      if (this.selectedType == "userpin") {
        if (this.userpin && this.userpin.length >= 4) {
          this.onClickInputType("passwordpin");
          this.$refs["userpasswordpin"].focus();
        } else {
          this.userpin = String(this.userpin + keyValue).slice(0, 4);
          if (
            this.userpin &&
            this.userpin.length >= 4 &&
            this.$refs["userpasswordpin"]
          ) {
            this.onClickInputType("passwordpin");
            this.$refs["userpasswordpin"].focus();
          }
          this.maybeAutoSubmitPinLogin();
        }
      } else if (this.selectedType == "passwordpin") {
        if (this.passwordpin && this.passwordpin.length >= 4) return;
        this.passwordpin = String(this.passwordpin + keyValue).slice(0, 4);
        this.maybeAutoSubmitPinLogin();
      }
    },
    onSliceNumber() {
      if (this.submitted) return;
      if (this.selectedType == "userpin") {
        if (this.userpin.length > 0) {
          this.userpin = this.userpin.slice(0, -1);
        }
        if (this.userpin.length == 0) {
          this.userpin = "";
        }
      } else if (this.selectedType == "passwordpin") {
        if (this.passwordpin.length > 0) {
          this.passwordpin = this.passwordpin.slice(0, -1);
        }
        if (this.passwordpin.length == 0) {
          this.passwordpin = "";
        }
      }
    },
    clearPinInput() {
      if (this.submitted) return;
      if (this.scanTimer) {
        clearTimeout(this.scanTimer);
        this.scanTimer = null;
      }
      this.userpin = "";
      this.passwordpin = "";
      this.selectedType = "userpin";
      this.focusScannerInput();
    },
    resetAuthFields() {
      this.username = "";
      this.password = "";
      this.userpin = "";
      this.passwordpin = "";
      this.cardScanData = "";
      this.selectedType = "userpin";
      this.showPassVKeyboard = false;
      this.showUsernameVKeyboard = false;
      this.submitted = false;
      this.showManualScan = false;
    },
    callOpenCashDrawer() {
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        ElectronAppService.openCashDrawer()
          .then((response) => {
            console.log("RESPONSE", response);
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      } else {
        console.log("CASH DRAWER OPEN ONLY FOR EXE");
      }
    },
    onClickInputHandler(event) {
      if (this.showUsernameVKeyboard && event == "password") {
        this.showUsernameVKeyboard = false;
        this.showPassVKeyboard = true;
      } else if (this.showUsernameVKeyboard && event == "username") {
        this.showUsernameVKeyboard = false;
        this.showPassVKeyboard = false;
      } else if (this.showPassVKeyboard && event == "username") {
        this.showUsernameVKeyboard = true;
        this.showPassVKeyboard = false;
      } else if (this.showPassVKeyboard && event == "password") {
        this.showUsernameVKeyboard = false;
        this.showPassVKeyboard = false;
      }
    },
    cancelAuth() {
      this.resetAuthFields();
      this.$emit("AuthValid", false);
      this.onCheckAuth({
        name: this.moduleName,
        valid: false,
        user_id: null,
        auth_unique_id: null,
      });
    },
    handleOpenCashDrawer(managerUserId) {
      if (!managerUserId) return;
      let userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
      let USERSHIFTDATA = JSON.parse(localStorage.getItem("USER_SHIFT_DATA"));
      console.log(userInfo, "userInfo");
      if (this.moduleName == "openCashDraw") {
        try {
          this.sendAuditLogs({
            action: `POS USER OPEN CASH DRAWER`,
            page_name: "CASH DRAWER",
            api_name: "",
          });

          let cinema_id = localStorage.getItem("cinema_id");
          let userData = localStorage.getItem("USER_INFO") || "";

          if (this.$socket) {
            console.log(
              "print_ticket from pos_login3123425454 open cash drawer"
            );

            if (
              CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME ||
              CLIENT_NAME.NOVO == this.CLIENT_SETUP_NAME
            ) {
              this.callOpenCashDrawer();
            } else {
              this.$socket.emit("on_print_ticket", {
                cinema_id,
                baseurl: BASEURL,
                ttype: "empire-login-ticket",
                openDrawer: "Y",
                loginDateTime: userData,
              });
            }
            console.log("print_ticket from pos_login");
            if (userInfo && USERSHIFTDATA) {
              PosService.CashDrawerLogs({
                cinema_id: userInfo.cinema_id,
                pos_logged_in_username: userInfo.username,
                pos_logged_in_userId: userInfo.user_id,
                auth_logged_in_userId: managerUserId,
                role_id: userInfo.role_id,
                role_name: userInfo.role_name,
                hardware_obj: USERSHIFTDATA.hardware_obj,
              });
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    authenticateByCard() {
      if (this.submitted) return;
      const rawValue = this.cardScanData;
      if (!rawValue || String(rawValue).trim() === "") {
        return;
      }

      const cleanedCardId = extractCleanCardScan(rawValue);
      if (!cleanedCardId) {
        this.$toasted.show("Please swipe a valid card or scan badge");
        return;
      }

      this.submitted = true;
      this.showLoading();
      PosService.CheckCinemaManagerScanAuth({
        auth_unique_id: cleanedCardId,
      })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.$emit("ManagerDetails", data.user_id, data.auth_unique_id);
            this.$emit("AuthUniqueId", data.auth_unique_id);
            this.resetAuthFields();
            this.$emit("AuthValid", true);

            this.onCheckAuth({
              name: this.moduleName,
              valid: true,
              user_id: data.user_id,
              auth_unique_id: data.auth_unique_id,
            });

            this.sendAuditLogs({
              operation: this.AUDIT_OPERATION.MANAGER_AUTH,
              outcome: this.AUDIT_OUTCOME.SUCCESS,
              message: "Manager authorization approved via Card/Scanner",
              details: {
                "For Action": this.moduleName,
                "Approved By (Manager ID)": data.user_id,
                "Auth Unique ID": data.auth_unique_id,
                "Manager Username": data.username,
              },
            });

            this.$refs[this.refId].hide();
            this.handleOpenCashDrawer(data.user_id);
          } else {
            this.submitted = false;
            this.cardScanData = "";
            this.$emit("ManagerDetails", null);
            this.$emit("AuthValid", false);
            this.onCheckAuth({
              name: this.moduleName,
              valid: false,
              user_id: null,
              auth_unique_id: null,
            });

            this.sendAuditLogs({
              operation: this.AUDIT_OPERATION.MANAGER_AUTH,
              outcome: this.AUDIT_OUTCOME.FAILED,
              message: (data && data.message) || "Manager authorization denied",
              details: {
                "For Action": this.moduleName,
                "Auth Unique ID": cleanedCardId,
              },
            });

            this.$toasted.show(
              (data && data.message) ||
                "Invalid card or badge. Kindly contact your administrator"
            );
            this.focusScannerInput();
          }
        })
        .catch((err) => {
          this.submitted = false;
          this.cardScanData = "";
          this.$emit("AuthValid", false);
          this.onCheckAuth({
            name: this.moduleName,
            valid: false,
            user_id: null,
            auth_unique_id: null,
          });

          this.sendAuditLogs({
            operation: this.AUDIT_OPERATION.MANAGER_AUTH,
            outcome: this.AUDIT_OUTCOME.FAILED,
            message: "Manager card authorization request failed",
            details: {
              "For Action": this.moduleName,
              "Auth Unique ID": cleanedCardId,
            },
          });
          console.log("Error:", err);
          this.$toasted.show(
            (err.response && err.response.data && err.response.data.message) ||
              "Sorry! Something went wrong. kindly contact your administrator"
          );
          this.focusScannerInput();
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    authenticateLogin() {
      if (this.submitted) {
        return;
      }

      if (this.isNovoClient) {
        const raw = String(this.userpin || "");
        if (
          raw.startsWith(";") ||
          raw.startsWith("%") ||
          /[a-zA-Z\-_]/.test(raw) ||
          raw.length > 4
        ) {
          this.userpin = "";
          const extracted = extractCleanCardScan(raw);
          if (extracted) {
            this.cardScanData = extracted;
          }
          this.focusScannerInput();
          this.authenticateByCard();
          return;
        }
      }

      const username = this.isNovoClient ? this.userpin : this.username;
      const password = this.isNovoClient ? this.passwordpin : this.password;

      if (
        !username ||
        !password ||
        String(username).trim() == "" ||
        String(password).trim() == ""
      ) {
        this.submitted = false;
        this.$toasted.show(
          this.isNovoClient
            ? "Please enter both PINs"
            : "Invalid username or password"
        );
        return;
      }

      this.submitted = true;
      this.showLoading();

      PosService.CheckCinemaManagerAuth({
        username,
        password,
      })
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.$emit("ManagerDetails", data.user_id);
            this.resetAuthFields();
            this.$emit("AuthValid", true);

            this.onCheckAuth({
              name: this.moduleName,
              valid: true,
              user_id: data.user_id,
            });

            this.sendAuditLogs({
              operation: this.AUDIT_OPERATION.MANAGER_AUTH,
              outcome: this.AUDIT_OUTCOME.SUCCESS,
              message: "Manager authorization approved",
              details: {
                "For Action": this.moduleName,
                "Approved By (Manager ID)": data.user_id,
                "Manager Username": username,
              },
            });

            this.$refs[this.refId].hide();
            this.handleOpenCashDrawer(data.user_id);
          } else {
            this.submitted = false;
            this.$emit("ManagerDetails", null);
            this.$emit("AuthValid", false);
            this.onCheckAuth({
              name: this.moduleName,
              valid: false,
              user_id: null,
            });

            this.sendAuditLogs({
              operation: this.AUDIT_OPERATION.MANAGER_AUTH,
              outcome: this.AUDIT_OUTCOME.FAILED,
              message: data.message || "Manager authorization denied",
              details: {
                "For Action": this.moduleName,
                "Manager Username": username,
              },
            });

            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
            if (this.isNovoClient) {
              this.clearPinInput();
            }
          }
        })
        .catch((err) => {
          this.submitted = false;
          this.$emit("AuthValid", false);
          this.onCheckAuth({
            name: this.moduleName,
            valid: false,
            user_id: null,
          });

          this.sendAuditLogs({
            operation: this.AUDIT_OPERATION.MANAGER_AUTH,
            outcome: this.AUDIT_OUTCOME.FAILED,
            message: "Manager authorization request failed",
            details: {
              "For Action": this.moduleName,
              "Manager Username": username,
            },
          });
          console.log("Error:", err);
          this.$toasted.show(
            (err.response && err.response.data && err.response.data.message) ||
              "Sorry! Something went wrong. kindly contact your administrator"
          );
          if (this.isNovoClient) {
            this.clearPinInput();
          }
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
};
</script>
<style>
.disbled-section {
  cursor: not-allowed;
  opacity: 0.4;
}

.managerAuthPop__title_class {
  font-size: 12px !important;
}

.managerAuthPop__header_class {
  padding: 0.4rem 1rem !important;
}

.managerAuthPop__modal_class--pin .modal-dialog {
  max-width: 360px;
  width: calc(100% - 24px);
  margin: 1.75rem auto;
}

.managerAuthPop__content_class--pin {
  padding: 16px 20px 20px !important;
}

.manager-auth-pin {
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
}

.manager-auth-pin__fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.manager-auth-pin__field {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
}

.manager-auth-pin__label {
  display: block;
  width: 100%;
  margin-bottom: 8px;
  color: #596273;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
}

.manager-auth-pin__box-wrap {
  position: relative;
  width: fit-content;
  height: 34px;
  display: grid;
  grid-template-columns: repeat(4, 28px);
  gap: 4px;
  margin: 0 auto;
  cursor: text;
}

.manager-auth-pin__native-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  opacity: 0;
  cursor: text;
}

.manager-auth-pin__digit-box {
  width: 28px;
  height: 34px;
  border: 1px solid #d8dee8;
  border-radius: 7px;
  color: #20242b;
  font-size: 15px;
  font-weight: 750;
  line-height: 32px;
  text-align: center;
  background: #ffffff;
  transition: border-color 0.16s ease, box-shadow 0.16s ease,
    background 0.16s ease;
}

.manager-auth-pin__digit-box.focused {
  border-color: var(--blue);
  box-shadow: 0 0 0 2px rgba(18, 44, 106, 0.1);
}

.manager-auth-pin__digit-box.filled {
  background: #f8fafc;
}

.manager-auth-pin__pad {
  width: 100%;
  max-width: 260px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.manager-auth-pin__key {
  height: 42px;
  border: 1px solid #dfe4ec;
  border-radius: 11px;
  color: #2b313b;
  font-size: 14px;
  font-weight: 700;
  background: #ffffff;
  cursor: pointer;
  transition: border-color 0.14s ease, background 0.14s ease;
}

.manager-auth-pin__key:hover,
.manager-auth-pin__key:focus {
  border-color: #b8c7dd;
  color: #1f2937;
  background: #f8fafc;
}

.manager-auth-pin__key:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  pointer-events: none;
}

.manager-auth-pin__key--muted {
  color: #64748b;
  background: #f1f5f9;
}

.manager-auth-pin__actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
}

.manager-auth-hidden-scanner-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  opacity: 0.01;
  border: 0;
  padding: 0;
  margin: 0;
  outline: none;
  background: transparent;
  color: transparent;
  z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/AuthManagerLoginPopup.vue